let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7nRPF")).then(() => parcelRequire('3zR7l'));